<template>
  <div id="Login" class="content">
    <div class="backstretch">
      <img src="../assets/bg.jpg" />
    </div>

    <div class="row login-box">
      <div class="login-wrap">
        <div class="col-md-6 mb-6 login-img"></div>

        <!--- **** MAINTENANCE PAGE CONTENT ******** -->
        <div v-if="isUnderMaintenance.value()" class="col-md-6 mb-6 login-form col-sm-12">
          <p>
            We are currently performing a <b>Scheduled Maintenance</b> from
            <strong>{{ isUnderMaintenance.startDate.toDateString() }} {{ isUnderMaintenance.startDate.toLocaleTimeString() }}</strong> to
            <strong>{{ isUnderMaintenance.endDate.toDateString() }} {{ isUnderMaintenance.endDate.toLocaleTimeString() }}</strong
            >.
          </p>
          <p><br /></p>
          <p>We apologise for any inconvenience this may cause and your patience is highly appreciated.</p>
        </div>

        <div v-else class="col-md-6 mb-6 login-form col-sm-12">
          <div class="login-header mb-5 row">
            <div class="col-md-10">
              <h4 class="mb-3 text-muted">Login</h4>
            </div>
            <div class="col-md-2 pl-0 pr-0">
              <img src="../assets/kagami.jpg" />
            </div>
          </div>

          <el-alert title="Welcome Back" type="success" :description="results" show-icon class="mt-3 mb-3" v-if="results !== false && errorresults === false">
          </el-alert>
          <el-alert title="" type="error" :description="errorresults" show-icon class="mt-3 mb-3" v-if="errorresults !== false && results === false">
          </el-alert>
          <form class="needs-validation" @submit.prevent="onSubmit">
            <div class="mb-3" :class="{ 'form-group--error': $v.usernameInput.$error }">
              <vs-input
                label-placeholder="Login ID"
                class="form-control text-left"
                id="username"
                v-model="usernameInput"
                v-model.trim="$v.usernameInput.$model"
              />

              <go-to-parent-portal v-if="usernameIsEmail" v-cloak />

              <div class="invalid-feedback" style="width: 100%">Your username is required.</div>
              <div class="error" style="color: red" v-if="!$v.usernameInput.required">Login ID is required</div>
            </div>

            <div class="mb-2" :class="{ 'form-group--error': $v.passwordInput.$error }" v-if="!usernameIsEmail">
              <vs-input
                type="password"
                label-placeholder="Password"
                class="form-control text-left"
                id="password"
                v-model="passwordInput"
                v-model.trim="$v.passwordInput.$model"
              />
              <div class="error" style="color: red" v-if="!$v.passwordInput.required">Password is required</div>
            </div>
            <div class="row d-flex mt-3 mb-5" v-if="!usernameIsEmail">
              <div class="col-md-6"></div>
              <div class="col-md-6">
                <button
                  class="g-recaptcha btn-primary btn-lg btn-block login-btn"
                  type="submit"
                  data-sitekey="6LfZ6rIaAAAAAOe0i6pf3rvpY0EIu9Os8ZHvWUka"
                  @click="onSubmit"
                >
                  Login
                </button>
                <small><a href="/reset-email">Forgot password</a></small>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import DataSource from '../data/datasource'
import parentRegisterComponent from '../components/Parent_Register_Component'
import GoToParentPortal from '../components/buttons/GoToParentPortal'
import { required } from 'vuelidate/lib/validators'
import Cookies from 'js-cookie'
import { EN_KEY, CH_KEY, changeLocale } from '../locale/index'

export default {
  data() {
    return {
      status: '',
      usernameInput: '',
      passwordInput: '',
      results: false,
      errorresults: false,
      isLoading: false,
      redirecting: '',
    }
  },
  computed: {
    request() {
      return JSON.stringify(this.usernameInput, null, '  ')
    },
    usernameIsEmail: function () {
      return String(this.usernameInput)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        )
    },

    isUnderMaintenance: function () {
      return {
        //SINGAPORE TIME
        startDate: new Date('September 28, 2024 20:00:00 UTC+08:00'),
        endDate: new Date('September 28, 2024 21:30:00 UTC+08:00'),

        //LOCAL (BROWSER) TIME
        currentDate: new Date(),

        value: function () {
          let urlParams = new URLSearchParams(window.location.search)
          console.log(urlParams.has('yourParam')) // true
          console.log(urlParams.get('yourParam')) // "MyParam"
          if (urlParams.has('admin') != undefined && urlParams.get('admin') == 'admin') {
            return false
          } else {
            if (this.currentDate >= this.startDate && this.currentDate <= this.endDate) {
              return true
            } else {
              return false
            }
          }
        },
      }
    },
  },
  methods: {
    async onSubmit() {
      this.$v.$touch()

      this.$vs.loading()

      try {
        const response = await DataSource.shared.login(this.usernameInput, this.passwordInput)
        this.redirecting = true

        const isParent = Cookies.get('userTypeSession')
        if (response) {
          this.$vs.loading.close()
          if (response.token) {
            this.results = `Login Success, Welcome Back`

            //configure website language
            if (response.WebsiteLanguage_Session === 'No Record' || response.WebsiteLanguage_Session === 'EN') {
              changeLocale(EN_KEY)
            } else if (response.WebsiteLanguage_Session === 'CH') {
              changeLocale(CH_KEY)
            } else {
              changeLocale(EN_KEY)
            }
            //configure website language

            if (isParent === 'Parent') {
              window.location.replace('/Feed')
            } else if (isParent === 'Teacher') {
              //sentosa,claymore,mis east,mis west, robersonwalk
              if (
                Cookies.get('schoolSession') === 'SCH201400000497' ||
                Cookies.get('schoolSession') === 'SCH201400000541' ||
                Cookies.get('schoolSession') === 'SCH201500000043' ||
                Cookies.get('schoolSession') === 'SCH201700000394' ||
                Cookies.get('schoolSession') === 'SCH201600000354' ||
                Cookies.get('schoolSession') === 'SCH201800000510' ||
                Cookies.get('schoolSession') === 'SCH202100000591'
              ) {
                window.location.replace('/Attendancelist')
              } else {
                window.location.replace('/StaffMainPage')
              }
            }
          } else {
            switch (response.code) {
              case '2':
                this.errorresults = `Invalid User Name or Password`
                break
              case '3':
                this.errorresults = `Invalid User Name or Password`
                break
              case '99':
                this.errorresults = `Please fill in all field`
                break
              default:
                alert('Please try again later')
                this.errorresults = JSON.stringify(response)
            }
            this.redirecting = false
          }
        }
      } catch (e) {
        console.log(e)
        this.errorresults = 'server error, please contact administrator'
        this.$vs.loading.close()
      }
    },
  },
  mounted() {
    const isLogin = Cookies.get('authToken')
    if (isLogin && isLogin !== 'null' && isLogin !== 'undefined') {
      this.results = `You already logged in`
      this.$router.go(-1)
    }
  },
  components: { GoToParentPortal, parentRegisterComponent },
  validations: {
    usernameInput: {
      required,
    },
    passwordInput: {
      required,
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  display: none;
}

#btn_FBLogin {
  background-color: #4267b2;
  border-radius: 4px;
  color: #fff;
  padding: 10px;
  border: 0;
  border-collapse: collapse;
  border-spacing: 0;

  font-family: Helvetica, Arial, sans-serif;
  letter-spacing: 0.25px;
  overflow: hidden;
  text-align: center;
  text-overflow: clip;
  white-space: nowrap;
  font-size: 16px;
  cursor: pointer;
  margin: 0 24px 0 12px;
}

#btn_FBLogin svg {
  width: 25px;
  height: 25px;
  margin-right: 10px;
}
</style>

<style>
.login div#parentx-static,
.login header {
  display: none;
}

.login .menu-box-wrap {
  display: none;
}
</style>
